export default __webpack_public_path__ + "static/media/cover_large_02.e8a1b405.jpg";